import { LanguageSelect } from "@/components/language-select";
import { onboardPath } from "@/constants";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/auth")({
  component: RouteComponent,
  beforeLoad: ({ context, location }) => {
    const shopifyRoute = location.pathname.startsWith("/auth/shopify");
    const ebayRoute = location.pathname.startsWith("/auth/ebay");
    const tiktokRoute = location.pathname.startsWith("/auth/tiktok");

    const shopifyLoginRoute = location.pathname.startsWith(
      "/auth/login/shopify",
    );

    if (
      context.auth.user.account &&
      !shopifyRoute &&
      !ebayRoute &&
      !tiktokRoute &&
      !shopifyLoginRoute
    ) {
      const orgs = context.auth.user.account.orgs;
      if (!orgs) {
        throw redirect({ to: onboardPath as string });
      }

      const currentOrg = context.org.orgId;
      const targetPath = `/${orgs.find((org) => org.id === currentOrg)?.slug ?? orgs[0].slug}/dashboard`;

      if (!location.pathname.startsWith(`/${orgs[0].slug}`)) {
        throw redirect({ to: targetPath });
      }

      return;
    }
  },
});

function RouteComponent() {
  return (
    <div>
      <LanguageSelect showLabel className="fixed top-4 right-4 z-10" />
      <Outlet />
    </div>
  );
}
